// project imports
import {
    processEntityInput as processEntityInputMain,
    processEntityOutput as processEntityOutputMain
} from 'store/serializers/fragments/main';
import {
    processEntityInput as processEntityInputSafeDeleter,
    processEntityOutput as processEntityOutputSafeDeleter
} from 'store/serializers/fragments/safe-deleter';
import {
    processEntityInput as processEntityInputLocker,
    processEntityOutput as processEntityOutputLocker
} from 'store/serializers/fragments/locker';
import { getIriFromObj } from 'utils/processors';
import {
    processEntityInput as processEntityInputExecSettings,
    processEntityOutput as processEntityOutputExecSettings
} from 'store/app/workmgmt/exec-settings';
import {
    processEntityInput as processEntityInputRecurSettings,
    processEntityOutput as processEntityOutputRecurSettings
} from 'store/app/workmgmt/recur-settings';
import {
    processEntityInput as processEntityInputTask,
    processEntityOutput as processEntityOutputTask,
    sortTasksByParentPosition
} from 'store/app/workmgmt/task';
import { processEntityInput as processEntityInputNote, processEntityOutput as processEntityOutputNote } from 'store/app/workmgmt/note';

export const processEntityInput = (values) => ({
    ...values,
    ...processEntityInputMain(values),
    ...processEntityInputSafeDeleter(values),
    ...processEntityInputLocker(values),
    execSettings: processEntityInputExecSettings(values?.execSettings),
    recurSettings: processEntityInputRecurSettings(values?.recurSettings),
    notes: values?.notes?.map((note) => processEntityInputNote(note))?.sort((n1, n2) => (n1.createdAt < n2.createdAt ? 1 : -1)),
    tasks: sortTasksByParentPosition(values?.tasks?.filter((task) => !task?.deletedAt)?.map((task) => processEntityInputTask(task)) || [])
});

export const processEntityOutput = (values) => ({
    ...values,
    ...processEntityOutputMain(values),
    ...processEntityOutputSafeDeleter(values),
    ...processEntityOutputLocker(values),
    color: undefined,
    metadata: undefined,
    businessOpportunity: getIriFromObj(values?.businessOpportunity) || undefined,
    workOrderType: getIriFromObj(values?.workOrderType) || undefined,
    department: getIriFromObj(values?.department) || undefined,
    client: getIriFromObj(values?.client) || undefined,
    responsible: getIriFromObj(values?.responsible) || undefined,
    participants:
        'participants' in (values || {}) && Array.isArray(values.participants)
            ? values.participants.map((part) => getIriFromObj(part) || null)
            : undefined,
    execSettings: processEntityOutputExecSettings(values?.execSettings),
    recurSettings: processEntityOutputRecurSettings(values?.recurSettings),
    notes:
        'notes' in (values || {}) && Array.isArray(values.notes)
            ? values.notes.map((note) => {
                  const { '@id': id, '@type': type, ...rest } = note;
                  return {
                      ...processEntityOutputNote(rest),
                      ...(!values?.id && values?.businessOpportunity ? {} : { '@id': id, '@type': type })
                  };
              })
            : undefined,
    tasks:
        'tasks' in (values || {}) && Array.isArray(values.tasks)
            ? values.tasks.map((task) => processEntityOutputTask({ ...task, workOrder: getIriFromObj(values) }))
            : undefined,
    sourceTask: 'sourceTask' in (values || {}) ? getIriFromObj(values.sourceTask) : undefined,
    sourceWorkOrder: 'sourceWorkOrder' in (values || {}) ? getIriFromObj(values.sourceWorkOrder) : undefined
});
